import queryString from 'query-string';

export const paramsExtract = (paramNames: Set<string>, navigate: any) => {
  const params = queryString.parse(location.search);
  const result: Record<string, string> = {};
  const newParams = Object.entries(params).filter(([key, value]) => {
    if (paramNames.has(key)) {
      result[key] = value as string;
      return false;
    }
    return true;
  });
  if (newParams.length < Object.keys(params).length) {
    const search = newParams.length ? '?' + newParams.join('&') : '';
    const url = location.pathname + search + location.hash;
    navigate(url, { replace: true });
  }
  return result;
};
